var metaInfo={
    title:"电子行业_Movibot服务行业",
    keywords:"电子行业_通信元器件激光焊接_视觉快速分拣_工业机器人",
    description:"工业机器人为电子行业提供物料搬运、视觉快速分拣、通信元器件激光焊接、上下料服务，助力零部件加工，提升生产协作能力，提升生产效率。",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/9.js